import { render, staticRenderFns } from "./main-space-and-equipment.vue?vue&type=template&id=65c6f818&scoped=true&"
import script from "./main-space-and-equipment.vue?vue&type=script&lang=js&"
export * from "./main-space-and-equipment.vue?vue&type=script&lang=js&"
import style0 from "./main-space-and-equipment.vue?vue&type=style&index=0&id=65c6f818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c6f818",
  null
  
)

export default component.exports